<script>

    import StatisticsQuotationsService from '../$services/statistics.quotations.service'
    import NumeralMethods from '../$methods/numeral.methods'

    import Card from './component.quotations.card.svelte'

    export let dateStart = null
    export let dateEnd = null

    let funnel = null
    let loading = false
    let error = false
    let seq = 0

    $: load(dateStart, dateEnd)

    $: subtitle = funnel ? `${NumeralMethods.number(funnel.total)} procesos de cotización.` : ''

    async function load(start, end) {
        if (!start || !end) return

        const id = ++seq

        loading = true
        const res = await StatisticsQuotationsService.getFunnel({
            dateStart: start.toISOString(),
            dateEnd: end.toISOString(),
        })

        // si el periodo cambió mientras cargaba, esta respuesta ya no aplica
        if (id !== seq) return

        loading = false
        error = !res?.success
        funnel = res?.success ? res.data : null
    }

    // cada etapa se mide contra el total de procesos de cotización
    function barWidth(count) {
        return funnel?.total ? (count / funnel.total) * 100 : 0
    }

</script>

<style>
    .stages,
    .abandonment {
        list-style: none;
        margin: 0;
        padding: 0;
    }

    .stage {
        margin-bottom: 1rem;
    }

    .stage-head {
        display: flex;
        justify-content: space-between;
        align-items: baseline;
        margin-bottom: 0.4rem;
        font-size: 0.95rem;
        font-weight: 700;
        color: #1a1a1a;
    }

    .stage-count {
        font-variant-numeric: tabular-nums;
    }

    .track {
        height: 1.1rem;
        background: #f3f4f6;
        border-radius: 6px;
        overflow: hidden;
    }

    .fill {
        height: 100%;
        background: #8bb592;
        border-radius: 6px;
    }

    .fill.is-final {
        background: #098E37;
    }

    .divider {
        border-top: 1px solid #e5e7eb;
        margin: 1.4rem 0 0.4rem;
    }

    .abandon-row {
        display: flex;
        justify-content: space-between;
        align-items: baseline;
        gap: 1rem;
        padding: 0.7rem 0;
        border-bottom: 1px solid #f1f1f1;
        font-size: 0.9rem;
        color: #374151;
    }

    .abandon-row:last-child {
        border-bottom: 0;
    }

    .abandon-count {
        font-variant-numeric: tabular-nums;
    }

    .note {
        margin-left: 0.4rem;
        font-size: 0.8rem;
        color: #9ca3af;
    }
</style>

<Card title="Abandono por etapa" { subtitle } { loading } { error } empty={ !!funnel && funnel.total === 0 }>
    {#if funnel}
        <ul class="stages">
            {#each funnel.steps as step, index (step.key)}
                <li class="stage">
                    <div class="stage-head">
                        <span>{ step.label }</span>
                        <span class="stage-count">{ NumeralMethods.number(step.count) }</span>
                    </div>
                    <div class="track">
                        <div class="fill" class:is-final={ index === funnel.steps.length - 1 } style="width: { barWidth(step.count) }%"></div>
                    </div>
                </li>
            {/each}
        </ul>

        <div class="divider"></div>

        <ul class="abandonment">
            {#each funnel.abandonment as row (row.key)}
                <li class="abandon-row">
                    <span>
                        { row.label }
                        {#if row.errors}
                            <span class="note">({ NumeralMethods.number(row.errors) } con error)</span>
                        {/if}
                    </span>
                    <span class="abandon-count">{ NumeralMethods.number(row.count) }</span>
                </li>
            {/each}
        </ul>
    {/if}
</Card>
